import styled from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled(Card)`
  width: 100%;
  height: auto;
  background-color: #ffffff;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 15px 0px;
  box-shadow: 0px 0px 10px #80808024;
  border: 1px solid #DFDFDF;
  border-radius: 11px;
  flex-direction: row;
  @media (max-width: 1100px){
    flex-direction: row;
  }
`;

export const Title = styled.div`
  font-size: 18px;
  color: #000FFF;
  cursor: pointer;

  @media (max-width: 768px){
    font-size: 14px;
  }
`;

export const ItemDetails = styled.span`
  color: #808080;
  font-size: 12px;
  font-weight: 300;
  margin-left: 0.4rem;
`;


export const DownloadIcon = styled.i`
  cursor: pointer;
  color: #487cf5;
  font-size: 25px;
`;

export const Divisor = styled.div`
  width: 1px;
  height: 51px;
  background-color: #707070;
  margin-left: 15px;
  margin-right: 15px;
  @media (max-width: 768px){
    visibility: hidden;
  }
`

export const Details = styled.div`
  margin-left: 24px;
  padding: 0px 10px;
  width: 90px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000FFF;
  color: #FFF;
  font-size: 12px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  cursor: pointer;
`

export const IconInformation = {
  width: 10,
  height: 10,
  marginLeft: 5
}

export const Left = styled.div`
  @media (min-width: 770px) {
    margin-left: 23px;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 770px) {
    display: flex;
    flex-direction: column;
    margin-left: .5rem;
  }
`

export const Right = styled.div`
  @media (min-width: 770px) {
    display:flex;
    justify-content:space-between;
    align-items:center;
    flex-direction:row;
  }

  @media(max-width: 770px) {
    display: flex;
    flex-direction: column;
    margin-right: .5rem;
  }
`

export const DownloadButton = styled.div`
`;

export const Column = styled.div`
  display: flex;
  align-items: center;
`;

export const BoxTitle = styled.div`
  @media(min-width: 770px) {
    width: 150px;
  }
`;

export const Dates = styled.div`
  display: flex;

  @media(max-width: 770px) {
    flex-direction: column;
  }
`;

export const DesktopContent = styled.div`
  @media(max-width: 770px) {
    display: none;
  }

  @media(min-width: 770px) {
    display: flex;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
`;

export const MobileContent = styled.div`
  @media(max-width: 770px) {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  @media(min-width: 770px) {
    display: none;
  }
`;
